import { Injectable } from '@angular/core';
import { Order } from '../models/order';
import { Observable, of } from 'rxjs';
import { Product } from '../models/product';
import { OrderInfo } from '../models/order-info';
import { TimeRestriction } from '../../booking/models/time-restriction';
import { OrderLine } from '../models/order-line';


@Injectable()
export class OrderService {

  createOrder(order: Order): Observable<Order> {
    return of();
  }

  createGuestOrder(order: Order): Observable<Order> {
    return of();
  }

  getOrder(orderId: number): Observable<Order> {
    return of();
  }

  getGuestOrder(orderId: number, orderKey: string): Observable<Order> {
    return of();
  }

  get loggedInPartnerOrders(): Observable<OrderInfo[]> {
    return of();
  }

  saleToInvoice(orderId: number): Observable<boolean> {
    return of();
  }

  changeOrderTimeSlot(orderId: number, date: Date, timeSlotId: number): Observable<any> {
    return of();
  }

  getOrderRestrictions(orderId: number): Observable<TimeRestriction[]> {
    return of();
  }

  cancelOrder(orderId: number): Observable<any> {
    return of();
  }

  refundOrder(orderId: number): Observable<any> {
    return of();
  }

  sendGuestOrderToEmail(orderId: number, orderKey: string, email: string): Observable<boolean> {
    return of();
  }
}
